import { createVNode as i, mergeProps as l } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RightArrowFilled.js";
import s from "../components/PfIcon.js";
const r = (t, o) => {
  const e = {
    ...t,
    ...o.attrs
  };
  return i(s, l(e, {
    icon: m
  }), null);
};
r.displayName = "RightArrowFilled";
r.inheritAttrs = !1;
export {
  r as default
};
